<template lang="pug">
  .product-price
    span.product-price__price {{ product.price | moneyWithoutDecimals }}
    s.product-price__price.product-price__price--compare-at(v-if="isOnSale") {{ comparePrice | moneyWithoutDecimals }}

</template>

<script>
  export default {
    name: 'ProductForm',
    props: {
      product: Object,
    },
    computed: {
      comparePrice() {
        const price = this.product.variants[0].compare_at_price;
        return !Number.isNaN(price) ? price : this.product.price;
      },
      isOnSale() {
        return this.comparePrice > this.product.price;
      },
    },
    methods: {},
  };
</script>

<style lang="scss">
  .product-price {
    margin: 0 0 ($spacing-unit * 5);
  }

  .product-price__price {
    display: inline-block;
    color: $color-black;
    font-size: rem(26);
    line-heigt: rem(33);

    @include tablet-up {
      font-size: rem(24);
      line-heigt: rem(30);
    }
  }

  .product-price__price--compare-at {
    margin: 0 $spacing-unit;
    color: $color-green-900;
  }
</style>
